/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  idUnidade: string | null;
  idsSerie: string[];
  porcentagemDesconto: string;
  idLeadCorretor: any;
  idOportunidade?: any;
}

export function useInserirDesconto(props: Props) {
  function convertToNumber(brNumber: string): number {
    const numberWithoutDots = brNumber.replace(/\./g, "");
    const numberWithDot = numberWithoutDots.replace(",", ".");
    return parseFloat(numberWithDot);
  }
  const postData = async () => {
    const INSERIR_DESCONTO = `${backofficeEnviroment}/common/oportunidades-lead/aplicar-desconto/v1`;
    const { data } = await instance.put(INSERIR_DESCONTO, {
      idUnidade: props.idUnidade,
      idsSerie: props.idsSerie,
      porcentagemDesconto: convertToNumber(props.porcentagemDesconto),
      idLeadCorretor: props.idLeadCorretor,
      idOportunidade: props.idOportunidade,
    });
    return data;
  };

  const mutation = useMutation(postData, {
    onSuccess: () => {
      toast.success("Desconto inserido com sucesso!");
    },
    onError: (error: any) => {
      toast.error(
        `Erro ao inserir desconto. Motivos: ${error.response.data.notifications.map(
          (item: any) => item?.message
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return mutation;
}
